import {Component, ViewChild} from '@angular/core';
import {NotificationServerEndpoint} from '@m4u-angular/core/endpoints/notification-server.endpoint';
import {BaseResponse, BaseState, NotificationServer, NotificationTestParams} from '@m4u-angular/base/entities/BaseEntities';
import {ServiceBagService, ServiceBagServices} from '@m4u-angular/base/component/ServiceBag';
import {BasePageCRUDComponent} from '@m4u-angular/base/component/BasePageCRUDComponent';
import {EnumMessageBoxTypes, EnumPageDisplayModes} from '@m4u-angular/core/framework/sysenums.enum';
import {ContextMenuElement} from '@base/classes/BaseClasses';
import {NotificationTestDialogComponent, State} from '@ui/notifications/notification-test-dialog/notification-test-dialog.component';
import {MessageBoxDialogComponent} from '@ui/dialogs/messagebox-dialog/messageboxdialog.component';

@Component({
    providers: ServiceBagServices,
    selector: 'app-notification-server',
    templateUrl: './notification-server.component.html'
})
export class NotificationServerComponent extends BasePageCRUDComponent<NotificationServer, BaseState, NotificationServerEndpoint>
{
    @ViewChild('dialog') dialog: NotificationTestDialogComponent;
    @ViewChild('messageBox') messageBox: MessageBoxDialogComponent;

    constructor(A: ServiceBagService, private endpoint: NotificationServerEndpoint, private notificationServerEndpoint: NotificationServerEndpoint)
    {
        super(A, 'NotificationServerComponent', NotificationServer, BaseState, endpoint, EnumPageDisplayModes.Window);
    }

    protected override OnEntitySaved() {
        this.NavigateBack();
    }

    protected override OnInitContextMenus(): ContextMenuElement[] {
        if (this.IsAddMode) { return undefined; }

        return [{
            text: this.RC('titleDelete'),
            visible: true,
            onClick: this.OnDelete.bind(this)
        }];
    }

    override OnDelete(): void {
        this.messageBox.Type = EnumMessageBoxTypes.YesNo;
        this.messageBox.Prompt = this.RC('msgDeleteNotificationServerQuestion');
        this.messageBox.ShowDialogShort(() => { this.DeleteEntity(); });
    }

    OnTestNotification() {
        this.dialog.ShowDialogShort((state: State) => {
            const params = new NotificationTestParams;
            params.NotificationServerID = this.Entity.EntryID;
            params.DeliveryOption = state.DeliveryOption;
            params.FromAddress = state.FromAddress;
            params.Address = state.Address;

            this.Do(this.notificationServerEndpoint.TestNotificationServer(params), true, undefined,
                (response: BaseResponse) => this.A.UI.StopMessage(this.RC('lblNotificationServerWrong')));
        });
    }

    OnPredefinedSmtpServerSelected(e: any) {
        this.Entity.SMTPServer = e.itemData.SMTPServer;
        this.Entity.SMTPPort = e.itemData.SMTPPort;
        this.Entity.SMTPUseSSL = e.itemData.SMTPUseSSL;
    }

    OnPredefinedSmsServerSelected(e: any) {
        this.Entity.SMSEndpoint = e.itemData.SMSEndpoint;
        this.Entity.SMSToken = e.itemData.SMSToken;
        this.Entity.SMSEndPointIsInforU = e.itemData.SMSEndPointIsInforU;
    }
}
